import React from 'react';

const MarketingContext = React.createContext({
   MARKETING_ITEMS: [],
   isReady: false,
});

export default MarketingContext;